// v-auto-width.js
const adjustColumnWidth = (el) => {
  // 必须延迟执行，等待 Element Plus 完成内部 DOM 分配
  setTimeout(() => {
    const tableHeader = el.querySelector('.el-table__header');
    const tableBody = el.querySelector('.el-table__body');
    if (!tableHeader || !tableBody) return;

    // 1. 获取所有表头单元格
    const ths = tableHeader.querySelectorAll('th');
    const colgroups = el.querySelectorAll('colgroup');
    ths.forEach((th, index) => {
      // 只处理带有 auto-width 类名的列
      if (th.classList.contains('auto-width')) {
        const cells = tableBody.querySelectorAll(`tr td:nth-child(${index + 1}) .cell`);
        const headerCell = th.querySelector('.cell');
        console.log(headerCell,'headerCell')
        // 计算当前列所有行（含表头）的最大宽度
        let maxWidth = getTextWidth(headerCell);
        cells.forEach(cell => {
          const w = getItemWidth(cell);
          if (w > maxWidth) maxWidth = w;
        });
        console.log(maxWidth,'maxWidthmaxWidth')
        // 设置宽度（32px 是 Element 默认的左右 padding 预留）
        const finalWidth = Math.ceil(maxWidth) + 34;

        // 核心：必须同时修改所有 colgroup 下对应的 col
        colgroups.forEach(colgroup => {
          const col = colgroup.querySelectorAll('col')[index];
          if (col) {
            col.style.width = `${finalWidth}px`;
          }
        });
      }
    });
  }, 0);
};

// Canvas 测量函数
export function getTextWidth(element) {
  if (!element) return 0;
  const text = element.innerText;
  const font = window.getComputedStyle(element).font;
  const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");
  context.font = font;
  return context.measureText(text).width;
}

const getItemWidth = (item) => {
  const todo = item.querySelectorAll('.table-todo-item')
  let todoWidthValue = (todo.length - 1) * 8 + 20
  todo.forEach(f => {
    todoWidthValue += f.getBoundingClientRect().width
  })
  console.log(todoWidthValue,'todoWidthValuetodoWidthValue')
  return todoWidthValue
}

export default {
  mounted(el) {
    adjustColumnWidth(el);
  },
  updated(el) {
    adjustColumnWidth(el);
  }
};